<kendo-tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab title="Option Translation" [selected]="true">
    <ng-template kendoTabContent>
      <kendo-grid [data]="manageTranslationGridView" [height]="470" [sortable]="true" [navigable]="true"
                  [filterable]="true" [groupable]="false" [reorderable]="true" [resizable]="true" [columnMenu]="false"
                  [pageSize]="productGridState.take" [skip]="productGridState.skip" (sortChange)="productGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }" [sort]="productGridState.sort" [filter]="productGridState.filter"
                  (pageChange)="productGridPageChange($event)" (dataStateChange)="productGridDataStateChange($event)"
                  [loading]="translationDataLoading">
        <kendo-grid-column field="id" title="Id" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionCode" title="Option Code" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionTranslation" title="Option Translation" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionApplicableProducts" title="Option Applicable Products" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column field="" title="" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            <!--Need to change the button-->
            <button title="edit" (click)="editTranslation(dataItem)" kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem, 'OptionTrans')">
              <span class="k-icon k-i-trash">
              </span>
            </button>
          </ng-template>
        </kendo-grid-command-column>

      </kendo-grid>
      <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
        <button [routerLink]="['/manageTranslation/add-translation']" [icon]="'plus'" class="m-3 clearKendoButton btn btn-success"
                kendoButton>
          Add New Translation
        </button>

      </div>
    </ng-template>
    
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="Option Value Translation">
    <ng-template kendoTabContent>
      <kendo-grid [data]="manageValueTranslationGridView" [height]="470" [sortable]="true" [navigable]="true"
                  [filterable]="true" [groupable]="false" [reorderable]="true" [resizable]="true" [columnMenu]="false"
                  [pageSize]="productValueGridState.take" [skip]="productValueGridState.skip" (sortChange)="productValueGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }" [sort]="productValueGridState.sort" [filter]="productValueGridState.filter"
                  (pageChange)="productValueGridPageChange($event)" (dataStateChange)="productValueGridDataStateChange($event)"
                  [loading]="translationDataLoading">
        <kendo-grid-column field="id" title="Id" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionCode" title="Option Code" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionValueCode" title="Option Value Code" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionValueTranslation" title="Option Value Translation" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="optionValueApplicableProducts" title="Option Value Applicable Products" [columnMenu]="false" [filterable]="true"
                           [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column field="" title="" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            <!--Need to change the button-->
            <button title="edit" (click)="editValueTranslation(dataItem)" kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem, 'OptionValueTrans')">
              <span class="k-icon k-i-trash">
              </span>
            </button>
          </ng-template>
        </kendo-grid-command-column>

      </kendo-grid>
      <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
        <button [routerLink]="['/manageTranslation/add-value-translation']" [icon]="'plus'" class="m-3 clearKendoButton btn btn-success"
                kendoButton>
          Add New Value Translation
        </button>

      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
<kendo-dialog title="Delete" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to delete this row?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      No
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
